import React from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const LoginPieChart = (props) => {
    const {datos} = props;
    
    const datosFormateados = [
        {
            name: "Mujeres",
            value: datos&&datos.acreMPorc,
            acreditados: datos&&datos.acreM
        },
        {
            name: "No binarios",
            value: datos&&datos.acreBPorc,
            acreditados: datos&&datos.acreB
        },
        {
            name: "Hombres",
            value: datos&&datos.acreHPorc,
            acreditados: datos&&datos.acreH
        }
    ];

    const COLORS = ['#DB2491', '#FD8C8C', '#2CC9D6'];

    const formatPorcentaje = numOriginal => {
        var resultado = "";
        resultado = Number(numOriginal).toFixed(2);
        resultado.toString();
        return resultado;
    };

    const CustomTooltip = ({active, payload, label}) => {
        if (active && payload && payload.length) {
            if(payload[0].name === "Mujeres") {
                return (
                    <div className="tooltipGrafica">
                        <b>&nbsp;Mujeres acreditadas&nbsp;</b><br/>&nbsp;{payload[0].payload.acreditados}
                    </div>
                );
            } else if(payload[0].name === "Hombres") {
                return (
                    <div className="tooltipGrafica">
                        <b>&nbsp;Hombres acreditados&nbsp;</b><br/>&nbsp;{payload[0].payload.acreditados}
                    </div>
                );
            } else {
                return (
                    <div className="tooltipGrafica">
                        <b>&nbsp;No binarios acreditados&nbsp;</b><br/>&nbsp;{payload[0].payload.acreditados}
                    </div>
                );
            }
        }
        return null;
    };

    if(datos) {
        return (
            <div>
                <ResponsiveContainer width="100%" minHeight={330} maxHeight={1040}>
                    <PieChart width={400} height={330}>
                        <Pie data={datosFormateados} dataKey="value" nameKey="name" cx="52%" cy="50%">
                            {datosFormateados.map((entry, index) =>(
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Legend payload={datosFormateados.map((item, index) => ({
                            id: item.name,
                            type: "circle",
                            value: <>&nbsp;&nbsp;{item.name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>
                                <span className={"legendAcre"+index}>{formatPorcentaje(item.value)}%</span></>,
                            color: COLORS[index % COLORS.length]
                        }))} />
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    } else {
        return <div>Cargando...</div>
    }
};

export default LoginPieChart;